import { useRouter } from 'next/router'
import Meta from 'components/meta/meta'
import Heading from 'components/heading/heading'
import AccountSettings from 'components/account-settings/account-settings'
import { post } from 'utils/api'
import { useModal } from 'components/modals/provider'
import { getRoute } from 'utils/helpers'
import useAppState from 'utils/state'

export default function Page() {
    const { showMessage } = useModal()
    const router = useRouter()
    const { user, setUser, showLoader } = useAppState()

    const handleSubmit = async data => {
        showLoader(true)
        const response = await post('account-register', data)
        showLoader(false)

        if (response.data.error) {
            showMessage(response.data.error)
        } else {
            setUser({ ...user, account_id: response.data.data.id })
            router.push(getRoute('account-contract'))
        }
    }

    if (user && !user.is_admin && user.account_id) {
        router.push(getRoute('account-dashboard'))
    }

    return (
        <>
            <Meta
                title="Registracija prekybai"
                description="Naujos lietuviskapreke.lt pardavėjo paskyros registracijos anketa."
            />
            <Heading size="30" tag="h1" center="1" className="mb72">
                Registruokitės ir prekiaukite per lietuviskapreke.lt
            </Heading>
            <div className="mb72">
                {user && (
                    <AccountSettings
                        endpoint="empty-account"
                        isAdmin={user && user.is_admin}
                        forRegistration={1}
                        onSubmit={handleSubmit}
                    />
                )}
            </div>
        </>
    )
}
